import mendeleev from "@/urls/mendeleev"
import {
  sendGetRequest,
} from "@/helper/requests"
// import {executeRequest} from "@/store/modules/utils";

const state = {
  infos: {
    currentUrl: null,
    items: [],
    loading: false,
    count: 0,
    detail: [],
    next: null,
    prev: null,
    error: null,
  }
}

const getters = {
  getInfos: state => state.infos.items,
  getInfosCount: state => state.infos.count,
  getInfosCurrentUrl: state => state.infos.currentUrl,
  getInfosNext: state => state.infos.next,
  getInfosPrev: state => state.infos.prev,
  getInfosDetail: state => state.infos.detail,
  isLoadingInfos: state => state.infos.loading,
  saveInfosError: state => state.infos.error,
}

const actions = {
  loadInfos: ({ commit, getters }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) {
      url = mendeleev.USER.INFOS.QUESTIONS.LIST()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingInfos) {
      commit('SET_INFOS_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_INFOS', data)
          commit('SET_INFOS_COUNT', data.count)
          commit('SET_INFOS_CURRENT_URL', url)
          commit('SET_INFOS_NEXT_URL', data.next)
          commit('SET_INFOS_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_INFOS_LOADING_END')
          commit('SAVE_INFOS_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  // loadInfosDetail: ({commit}, {url, id, finalizer=()=>{}, catcher=()=>{}}) => {
  //   if (!url) url = url = mendeleev.USER.PARTNERS.INFOS.DETAIL(id)
  //   sendGetRequest(
  //     url, (data, url) => {
  //       commit('SET_INFOS_DETAIL', data);
  //       finalizer(data, url);
  //     }, (data, url) => {
  //       commit('SAVE_INFOS_ERROR', data);
  //       catcher(data, url);
  //     }
  //   )
  // },
}

const mutations = {
  SET_INFOS: (state, value) => {
    state.infos.items = value
  },
  SET_INFOS_DETAIL: (state, value) => {
    state.infos.detail = value
  },
  SET_INFOS_COUNT: (state, value) => {
    state.infos.count = value
  },
  SET_INFOS_CURRENT_URL: (state, value) => {
    state.infos.currentUrl = value
  },
  SET_INFOS_NEXT_URL: (state, value) => {
    state.infos.next = value
  },
  SET_INFOS_PREV_URL: (state, value) => {
    state.infos.prev = value
  },
  SET_INFOS_LOADING: (state) => {
    state.infos.loading = true
  },
  SET_INFOS_LOADING_END: (state) => {
    state.infos.loading = false
  },
  SAVE_INFOS_ERROR: (state, error) => {
    state.infos.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
